<template>
    <div>
        <v-dialog
            width="500"
            v-model="display"
            persistent>
            <v-card>
                <v-card-title>{{ $t("extend_sales_order") }}</v-card-title>
                <v-card-text>
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-menu
                            ref="menu_validity_date"
                            v-model="menu.validity_date"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="form.validity_date"
                                    :rules="rules.validity_date"
                                    :label="$t('validity_date')"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="form.validity_date" @input="menu.validity_date = false" no-title scrollable></v-date-picker>
                        </v-menu>
                        <v-textarea
                            :label="$t('note')"
                            v-model="form.notes"
                            :rules="rules.notes">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn text :disabled="!valid || loading.submit" :loading="loading.submit" @click="submit">{{$t("save_btn")}}</v-btn>
                    <v-btn text @click="close">{{ $t("cancel_btn") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import AlertDialog from '../common/AlertDialog';
import moment from 'moment';

export default {
    name: "SalesOrderExtendDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display:false,
            valid: false,
            params: {},
            menu: {
                validity_date: false
            },
            form: {
                validity_date: null,
                notes: null
            },
            loading: {
                submit: false
            },
            rules: {
                validity_date: [
                    v => !!v || this.$t("rules_required")
                ],
                notes: [
                    v => !!v || this.$t("rules_required")
                ]
            }
        }
    },
    methods: {
        ...mapActions("sales/salesOrder", ["extendSalesOrder"]),
        open(params) {
            this.display = true;
            this.params = params;
            this.form.validity_date = moment().format("YYYY-MM-DD");
        },
        submit() {
            this.loading.submit = true;
            this.extendSalesOrder({id: this.params.id, ...this.form})
                .then(() => {
                    this.loading.submit = false;
                    this.$emit("submit");
                    this.close();
                })
                .catch(error => {
                    this.loading.submit = false;
                    let message = error.response ? error.response.data.message : error;
                    this.$refs.alertDialog.open({type: "error", message});
                })
        },
        close() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.$refs.form.resetValidation();
        }
    }
}
</script>